@if (currentPage()?.data) {
  <div class="related-party-card-container">
    @for (relatedParty of currentPage()!.data; track relatedParty) {
    <div class="card" [attr.aria-label]="relatedParty.name">
      <svg-icon [src]="relatedParty.icon.url" svgClass="icon"></svg-icon>
      <div class="details">
        <div class="name">{{relatedParty.name}}</div>
        @if (relatedParty.description) {
          <div class="description">{{relatedParty.description}}</div>
        }
      </div>
      @if (!relatedParty.dateResigned) {
        <div class="status active">ACTIVE</div>
      }
      @if (relatedParty.dateResigned) {
        <div class="status resigned">RETIRED</div>
      }
    </div>
    }
  </div>
}
